export default __webpack_public_path__ + "static/media/Optimized-pexels-mikael-blomkvist-6476798.0c1617e6.jpg";